import React from 'react';
import styled from 'styled-components';
import { colors } from '../styles/GlobalStyles';

const ProgramListWrapper = styled.section` /* Changed to section for semantics */
  padding: 30px 20px; /* Adjusted padding */
  margin-bottom: 40px;
  max-width: 1100px; /* Limit max width for better centering */
  margin-left: auto;
  margin-right: auto;
`;

const ListTitle = styled.h2`
  color: ${colors.forestGreen};
  text-align: center;
  margin-bottom: 30px; /* Increased spacing */
`;

const ProgramGrid = styled.div`
  display: grid;
  /* Responsive grid: 2 cols mobile, 3 medium, 4 large */
  grid-template-columns: repeat(2, 1fr);
  gap: 15px; /* Reduced gap */

  @media (min-width: 768px) { /* Adjusted breakpoint */
    grid-template-columns: repeat(3, 1fr);
    gap: 20px; /* Adjusted gap */
  }

  @media (min-width: 1100px) { /* Adjusted breakpoint */
    grid-template-columns: repeat(4, 1fr);
  }
`;

const ProgramCard = styled.div`
  background-color: ${colors.white};
  padding: 10px; /* Reduced padding */
  border-radius: 10px; /* Slightly reduced radius */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  border: 1px solid ${colors.warmGray};
  text-align: center;
  font-family: sans-serif;
  font-size: 0.9em; /* Reduced font size */
  font-weight: 600;
  color: ${colors.navyBlue};
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 70px; /* Reduced min-height */
  /* Allow text to wrap */
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

// Updated program list
const programs = [
  "Lavazza",
  "Starbucks",
  "Peet's Coffee",
  "RC Bigelow",
  "Nestle Coffee-Mate",
  "Georgia-Pacific",
  "Sugar Food Corporation",
  "Customer Beverage Concepts",
  "SCA Tissue North America",
  "Smithfield Foods",
  "National Beverage Corp: Shasta, LaCroix",
  "John B Sanflippo and Sons",
  "Domino Foods",
  "J&J Snack Foods",
  "Ekaterra: Lipton Tea",
  "Wandering Bear",
  "Rich Products Corporation",
  "Ricos Products",
  "McCain Foods",
  "Michael Food",
  "Nathan's Famous"
];

const ProgramList: React.FC = () => {
  return (
    <ProgramListWrapper>
      <ListTitle>Available Rebate Programs</ListTitle>
      <ProgramGrid>
        {programs.map((program, index) => (
          <ProgramCard key={index}>{program}</ProgramCard>
        ))}
      </ProgramGrid>
      {/* Add more descriptive text if necessary */}
    </ProgramListWrapper>
  );
};

export default ProgramList; 